module.exports = __webpack_public_path__ + "img/kbi_mini.576deca9.png";